import { render } from "./index.vue?vue&type=template&id=87848dfc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=87848dfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87848dfc"],['__file',"src/components/DesHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87848dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87848dfc', __exports__)) {
    api.reload('87848dfc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=87848dfc&scoped=true", () => {
    api.rerender('87848dfc', render)
  })

}


export default __exports__